import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { DinoProfile } from '@jdiyield/abi';
import { DINO_PROFILE } from '@jdiyield/constants';
import Web3 from 'web3';
import getNodeUrl from './rpcRandom';
export var getUserProfile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(walletAddress) {
    var web3, contract, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            web3 = new Web3(getNodeUrl(56));
            contract = new web3.eth.Contract(DinoProfile, DINO_PROFILE);
            _context.next = 5;
            return contract.methods.getUserProfile(walletAddress).call();

          case 5:
            result = _context.sent;
            return _context.abrupt("return", {
              userId: result[0],
              numberPoints: result[1],
              exp: result[2],
              tokenId: result[3],
              registeredDate: result[4],
              nftAddress: result[5],
              isActive: result[6]
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function getUserProfile(_x) {
    return _ref.apply(this, arguments);
  };
}();